import React from 'react';

interface YouTubeEmbedProps {
    embedCode: string;
    className?: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ embedCode, className = "" }) => {
    // Basic regex to extract src from embed code if needed, but for simplicity
    // we'll just trust the provided iframe and wrap it responsively.
    
    return (
        <div className={`relative w-full overflow-hidden rounded-2xl shadow-xl border border-white/10 group ${className}`}>
            <div className="aspect-video w-full">
                {/* We inject the iframe directly but ensure it respects the container's layout */}
                <div 
                    className="w-full h-full [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:rounded-2xl"
                    dangerouslySetInnerHTML={{ __html: embedCode }} 
                />
            </div>
            {/* Subtle overlay for 'premium' feel */}
            <div className="absolute inset-0 pointer-events-none rounded-2xl ring-1 ring-inset ring-black/5"></div>
        </div>
    );
};

export default YouTubeEmbed;
